module.exports = __webpack_public_path__ + "img/banner1-1.3eb95884.png";